/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.16.0
 * @since 1.16.0
 */

import { IPersonalDataConfirm } from './personalDataConfirmTypes';

export interface IPersonalDataConfirmCheckResponse {
    accountsNotConfirmed: boolean;
    subscribersNotConfirmed: boolean;
}

export const mapPersonalDataConfirmCheck = (response?: IPersonalDataConfirmCheckResponse): IPersonalDataConfirm => ({
    accountsNotConfirmed: response?.accountsNotConfirmed || false,
    subscribersNotConfirmed: response?.subscribersNotConfirmed || false,
});
